// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container_Ue4DS {
  position: static;
  top: unset;
  left: unset;
  background: var(--f5-background);
  width: 100vw;
  height: 100vh;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: stretch;
  z-index: 1;
}

.content_HMBmc {
  width: 100%;
  max-width: 100vw;
  min-height: 100vh;
  height: 100%;
  display: flex;
  flex-direction: column;
  /* background-color: var(--f5-background); */
  border-radius: 0;
  position: static;
  top: unset;
  left: unset;
  z-index: 1;
  box-shadow: none;
  margin: 0;
  padding: 0;
}

@media (max-width: 768px) {
  .content_HMBmc {
    max-width: 100vw;
    width: 100vw;
    min-height: 100vh;
    height: 100vh;
    border-radius: 0;
    padding: 0;
  }
  .container_Ue4DS {
    min-height: 100vh;
    height: 100vh;
    width: 100vw;
    border-radius: 0;
    padding: 0;
  }
}

.scaleInitial_yEJ3B {
  transform: translate(-50%, -50%) scale(0);
  opacity: 0;
}

.scaleIn_CVfdz {
  transform: translate(-50%, -50%) scale(1);
  opacity: 1;
  transition: transform 0.3s ease-out, opacity 0.3s ease-out;
}

.scaleOut_KgRhs {
  transform: translate(-50%, -50%) scale(0);
  opacity: 0;
  transition: transform 0.3s ease-in, opacity 0.3s ease-in;
}

.expand_HJLTy {
  /* max-width: 735px; */
}
.iniAutomateContainer_pGa3X {
  /* width: 735px;
  overflow: scroll; */
}
.automateContainer_P1C8L {
  /* width: 530px; */
}

.iniContainer_Ua5qE {
  padding: 0 22px;
  box-sizing: border-box;
  background-color: var(--f5-background);
}

.automate_content_CvCNX {
  display: flex;
  flex-direction: column;
  padding: 10px;
  padding-top: 0;
  gap: 10px;
  /* overflow: hidden; */
  /* background: var(--f5-background); */
}

.content_HMBmc::-webkit-scrollbar {
  display: none;
}

.footer_jhial {
  width: 100%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  background-color: var(--f5-background);
  box-sizing: border-box;
  padding: 10px 0px;

  @media (width<=528px) {
    & {
      padding: 30px 10px 22px 10px;
    }
  }
}




.scaleDown_sX_EE {
  animation: scaleDown_sX_EE 300ms ease-in forwards;
  -webkit-animation: scaleDown_sX_EE 300ms ease-in forwards;
  animation-fill-mode: forwards
}

@keyframes scaleUp_O5oc8 {
  from {
    transform: translate(-50%, -50%) scale(0);
    -webkit-transform: translate(-50%, -50%) scale(0);
    -moz-transform: translate(-50%, -50%) scale(0);
    -ms-transform: translate(-50%, -50%) scale(0);
    -o-transform: translate(-50%, -50%) scale(0);
  }

  to {
    transform: translate(-50%, -50%) scale(1);
    -webkit-transform: translate(-50%, -50%) scale(1);
    -moz-transform: translate(-50%, -50%) scale(1);
    -ms-transform: translate(-50%, -50%) scale(1);
    -o-transform: translate(-50%, -50%) scale(1);
  }
}

@keyframes scaleDown_sX_EE {
  from {
    transform: translate(-50%, -50%) scale(1);
  }

  to {
    transform: translate(-50%, -50%) scale(0);
    -webkit-transform: translate(-50%, -50%) scale(0);
    -moz-transform: translate(-50%, -50%) scale(0);
    -ms-transform: translate(-50%, -50%) scale(0);
    -o-transform: translate(-50%, -50%) scale(0);
  }
}

.fadeOut_djDEH {
  opacity: 0;
}


.headerLeft_svBVT {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  color: var(--_2-color);
  font-size: 20px;
  font-weight: 600;
  gap: 33px;
  width: 100%;

  h2 {
    font-size: 22px;
    font-weight: 600;
    color: var(--black-color);
  }

  b {
    margin-left: auto;
  }
}

.closeIcon_meqNN {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 31px;
  height: 31px;
  cursor: pointer;
  border-radius: 4px;
  background: var(--f6-background);
  -webkit-user-select: none;
          user-select: none;
}

.backButton_Er5FW {
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  width: 23px;
  height: 23px;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  background: var(--_10a37f-background);
}

.closeIcon_meqNN {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 31px;
  height: 31px;
  cursor: pointer;
  border-radius: 4px;
  background: var(--f6-background);
  -webkit-user-select: none;
          user-select: none;
}

.searchContainer_qIz4a {
  display: flex;
  gap: 10px;
  align-items: center;
  padding: 12px 20px;
    background: white;
}

.searchInputWrapper_PD_wa {
  display: flex;
  align-items: center;
  background: var(--white-background);
  height: 35px;
  width: 100%;
  min-height: 35px;
  border: 1px solid var(--d9d9e3-border);
  border-radius: 8px;
  padding: 0px 14px;
}

.searchIconsWrappers_fQreT {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  background: var(--ececf1-background);
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  border-radius: 3px;
}

.searchIcon_rMW2B {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  color: var(--_6-color);
}

.searchInput_hkuu4 {
  flex: 1 1;
  padding: 8px;
  border: none;
  background: transparent;
  outline: none;
}

.searchInput_hkuu4::placeholder {
  color: var(--_6-color);
}


.contentContainerScroll_lc0N_ {
  overflow: hidden;
  overflow-y: auto;
}
.contentContainer_su_0f {
  /* border: 2px dashed var(--ececf1-background); */
  border-radius: 8px;
  /* max-height: 60vh; */
  overflow: scroll;
}

.contentContainer_su_0f::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

.contentContainer_su_0f::-webkit-scrollbar-thumb {
  background-color: var(--e2-background);
  border-radius: 12px;
}

.contentContainer_su_0f::-webkit-scrollbar-track {
  background: var(--white-background);
}

.noAutomations_pSoZ3 {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  flex-direction: column;
  padding: 20px;
  background-color: var(--white-background);
}


.paginationTableContainer_ljneZ{
  display: flex;
  justify-content: end;
  width: 100%;
}
.automationIconContainer_pbIS4{
  background-color: var(--white-background);
  transition: background-color 0.3s ease;
  border-radius: 5px;
  cursor: pointer;
  stroke: rgb(119, 119, 119) !important;
  svg{
    &:hover {
      stroke: #8f8f8f !important;
    }
  }
}

.noAutomationsTextWrapper_R8SWL{
      display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 1%;
}

.scaleUp_O5oc8 {
  transform: scale(0.08); 
  opacity: 0;
  transition: transform 0.3s ease, opacity 0.3s ease;
}


.typeContact_U59k7 {
  display: flex;
  background-color: var(--white-background);
  border-radius: 6px;
  -webkit-border-radius: 6px;
  -moz-border-radius: 6px;
  -ms-border-radius: 6px;
  -o-border-radius: 6px;
  padding: 12px 20px;
  gap: 20px;
  width: 100%;
  height: fit-content;
  box-sizing: border-box;
  /* overflow-x: auto; */


  button {
    background-color: transparent;
    cursor: pointer;
    color: var(--_6-color);
    font-family: Inter;
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: 24px;
    border-radius: 8px;
    -webkit-border-radius: 8px;
    -moz-border-radius: 8px;
    -ms-border-radius: 8px;
    -o-border-radius: 8px;
    /* border: 1px solid transparent !important; */
    border: none !important;
    /* flex: 1; */
    background-color: transparent;
    max-height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 8px;
    outline: none;
    gap: 10px;

    span{
      background-color: var(--white-background);
      color: #181818;
                  height: 16px;
            width: 16px;
            display: flex
;
            padding: 2px;
            border-radius: 4px;
            justify-content: center;
            align-items: center;
    }
}

 .selected_Ps0lE {
    background-color: var(--ececf1-background);
    /* color: var(--_0d-color); */
    border-radius: 8px;
    border:none !important;
    box-shadow:
      0px 0px 2px 0px var(--_00000008-shadow),
      0px 0px 0px 0px var(--_00000000-shadow),
      0px 0px 0px 0px var(--_00000000-shadow);
  }
}
.buttonsContainer_xJ_pF{
  display: flex;
  justify-content: space-between;
  width: 100%;
  background-color: var(--white-background);
  border-radius: 6px;
  -webkit-border-radius: 6px;
  -moz-border-radius: 6px;
  -ms-border-radius: 6px;
  -o-border-radius: 6px;
  padding: 12px 20px;

  .rightButtonsContainer_Sgl63{
    display: flex;
    align-items: center;
    gap: 10px;
  }
}

`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/components/Automate/automate.module.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,UAAU;EACV,WAAW;EACX,gCAAgC;EAChC,YAAY;EACZ,aAAa;EACb,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,oBAAoB;EACpB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,4CAA4C;EAC5C,gBAAgB;EAChB,gBAAgB;EAChB,UAAU;EACV,WAAW;EACX,UAAU;EACV,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE;IACE,gBAAgB;IAChB,YAAY;IACZ,iBAAiB;IACjB,aAAa;IACb,gBAAgB;IAChB,UAAU;EACZ;EACA;IACE,iBAAiB;IACjB,aAAa;IACb,YAAY;IACZ,gBAAgB;IAChB,UAAU;EACZ;AACF;;AAEA;EACE,yCAAyC;EACzC,UAAU;AACZ;;AAEA;EACE,yCAAyC;EACzC,UAAU;EACV,0DAA0D;AAC5D;;AAEA;EACE,yCAAyC;EACzC,UAAU;EACV,wDAAwD;AAC1D;;AAEA;EACE,sBAAsB;AACxB;AACA;EACE;qBACmB;AACrB;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,cAAc;EACd,SAAS;EACT,sBAAsB;EACtB,sCAAsC;AACxC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,sCAAsC;EACtC,sBAAsB;EACtB,iBAAiB;;EAEjB;IACE;MACE,4BAA4B;IAC9B;EACF;AACF;;;;;AAKA;EACE,iDAA2C;EAC3C,yDAAmD;EACnD;AACF;;AAEA;EACE;IACE,yCAAyC;IACzC,iDAAiD;IACjD,8CAA8C;IAC9C,6CAA6C;IAC7C,4CAA4C;EAC9C;;EAEA;IACE,yCAAyC;IACzC,iDAAiD;IACjD,8CAA8C;IAC9C,6CAA6C;IAC7C,4CAA4C;EAC9C;AACF;;AAEA;EACE;IACE,yCAAyC;EAC3C;;EAEA;IACE,yCAAyC;IACzC,iDAAiD;IACjD,8CAA8C;IAC9C,6CAA6C;IAC7C,4CAA4C;EAC9C;AACF;;AAEA;EACE,UAAU;AACZ;;;AAGA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,SAAS;EACT,WAAW;;EAEX;IACE,eAAe;IACf,gBAAgB;IAChB,yBAAyB;EAC3B;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,gCAAgC;EAChC,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;EACjB,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,gCAAgC;EAChC,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,kBAAkB;IAChB,iBAAiB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mCAAmC;EACnC,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,sCAAsC;EACtC,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,sBAAsB;AACxB;;;AAGA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,iDAAiD;EACjD,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,sCAAsC;EACtC,mBAAmB;AACrB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,sBAAsB;EACtB,aAAa;EACb,yCAAyC;AAC3C;;;AAGA;EACE,aAAa;EACb,oBAAoB;EACpB,WAAW;AACb;AACA;EACE,yCAAyC;EACzC,sCAAsC;EACtC,kBAAkB;EAClB,eAAe;EACf,qCAAqC;EACrC;IACE;MACE,0BAA0B;IAC5B;EACF;AACF;;AAEA;MACM,aAAa;IACf,sBAAsB;IACtB,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,kDAAkD;AACpD;;;AAGA;EACE,aAAa;EACb,yCAAyC;EACzC,kBAAkB;EAClB,0BAA0B;EAC1B,uBAAuB;EACvB,sBAAsB;EACtB,qBAAqB;EACrB,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,mBAAmB;EACnB,sBAAsB;EACtB,sBAAsB;;;EAGtB;IACE,6BAA6B;IAC7B,eAAe;IACf,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,0BAA0B;IAC1B,uBAAuB;IACvB,sBAAsB;IACtB,qBAAqB;IACrB,8CAA8C;IAC9C,uBAAuB;IACvB,aAAa;IACb,6BAA6B;IAC7B,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,aAAa;IACb,SAAS;;IAET;MACE,yCAAyC;MACzC,cAAc;kBACF,YAAY;YAClB,WAAW;YACX;AACZ;YACY,YAAY;YACZ,kBAAkB;YAClB,uBAAuB;YACvB,mBAAmB;IAC3B;AACJ;;CAEC;IACG,0CAA0C;IAC1C,6BAA6B;IAC7B,kBAAkB;IAClB,sBAAsB;IACtB;;;6CAGyC;EAC3C;AACF;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,WAAW;EACX,yCAAyC;EACzC,kBAAkB;EAClB,0BAA0B;EAC1B,uBAAuB;EACvB,sBAAsB;EACtB,qBAAqB;EACrB,kBAAkB;;EAElB;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;EACX;AACF","sourcesContent":[".container {\n  position: static;\n  top: unset;\n  left: unset;\n  background: var(--f5-background);\n  width: 100vw;\n  height: 100vh;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  align-items: stretch;\n  z-index: 1;\n}\n\n.content {\n  width: 100%;\n  max-width: 100vw;\n  min-height: 100vh;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  /* background-color: var(--f5-background); */\n  border-radius: 0;\n  position: static;\n  top: unset;\n  left: unset;\n  z-index: 1;\n  box-shadow: none;\n  margin: 0;\n  padding: 0;\n}\n\n@media (max-width: 768px) {\n  .content {\n    max-width: 100vw;\n    width: 100vw;\n    min-height: 100vh;\n    height: 100vh;\n    border-radius: 0;\n    padding: 0;\n  }\n  .container {\n    min-height: 100vh;\n    height: 100vh;\n    width: 100vw;\n    border-radius: 0;\n    padding: 0;\n  }\n}\n\n.scaleInitial {\n  transform: translate(-50%, -50%) scale(0);\n  opacity: 0;\n}\n\n.scaleIn {\n  transform: translate(-50%, -50%) scale(1);\n  opacity: 1;\n  transition: transform 0.3s ease-out, opacity 0.3s ease-out;\n}\n\n.scaleOut {\n  transform: translate(-50%, -50%) scale(0);\n  opacity: 0;\n  transition: transform 0.3s ease-in, opacity 0.3s ease-in;\n}\n\n.expand {\n  /* max-width: 735px; */\n}\n.iniAutomateContainer {\n  /* width: 735px;\n  overflow: scroll; */\n}\n.automateContainer {\n  /* width: 530px; */\n}\n\n.iniContainer {\n  padding: 0 22px;\n  box-sizing: border-box;\n  background-color: var(--f5-background);\n}\n\n.automate_content {\n  display: flex;\n  flex-direction: column;\n  padding: 10px;\n  padding-top: 0;\n  gap: 10px;\n  /* overflow: hidden; */\n  /* background: var(--f5-background); */\n}\n\n.content::-webkit-scrollbar {\n  display: none;\n}\n\n.footer {\n  width: 100%;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 4px;\n  background-color: var(--f5-background);\n  box-sizing: border-box;\n  padding: 10px 0px;\n\n  @media (width<=528px) {\n    & {\n      padding: 30px 10px 22px 10px;\n    }\n  }\n}\n\n\n\n\n.scaleDown {\n  animation: scaleDown 300ms ease-in forwards;\n  -webkit-animation: scaleDown 300ms ease-in forwards;\n  animation-fill-mode: forwards\n}\n\n@keyframes scaleUp {\n  from {\n    transform: translate(-50%, -50%) scale(0);\n    -webkit-transform: translate(-50%, -50%) scale(0);\n    -moz-transform: translate(-50%, -50%) scale(0);\n    -ms-transform: translate(-50%, -50%) scale(0);\n    -o-transform: translate(-50%, -50%) scale(0);\n  }\n\n  to {\n    transform: translate(-50%, -50%) scale(1);\n    -webkit-transform: translate(-50%, -50%) scale(1);\n    -moz-transform: translate(-50%, -50%) scale(1);\n    -ms-transform: translate(-50%, -50%) scale(1);\n    -o-transform: translate(-50%, -50%) scale(1);\n  }\n}\n\n@keyframes scaleDown {\n  from {\n    transform: translate(-50%, -50%) scale(1);\n  }\n\n  to {\n    transform: translate(-50%, -50%) scale(0);\n    -webkit-transform: translate(-50%, -50%) scale(0);\n    -moz-transform: translate(-50%, -50%) scale(0);\n    -ms-transform: translate(-50%, -50%) scale(0);\n    -o-transform: translate(-50%, -50%) scale(0);\n  }\n}\n\n.fadeOut {\n  opacity: 0;\n}\n\n\n.headerLeft {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  color: var(--_2-color);\n  font-size: 20px;\n  font-weight: 600;\n  gap: 33px;\n  width: 100%;\n\n  h2 {\n    font-size: 22px;\n    font-weight: 600;\n    color: var(--black-color);\n  }\n\n  b {\n    margin-left: auto;\n  }\n}\n\n.closeIcon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 31px;\n  height: 31px;\n  cursor: pointer;\n  border-radius: 4px;\n  background: var(--f6-background);\n  user-select: none;\n}\n\n.backButton {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 4px;\n  width: 23px;\n  height: 23px;\n  cursor: pointer;\n  user-select: none;\n  background: var(--_10a37f-background);\n}\n\n.closeIcon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 31px;\n  height: 31px;\n  cursor: pointer;\n  border-radius: 4px;\n  background: var(--f6-background);\n  user-select: none;\n}\n\n.searchContainer {\n  display: flex;\n  gap: 10px;\n  align-items: center;\n  padding: 12px 20px;\n    background: white;\n}\n\n.searchInputWrapper {\n  display: flex;\n  align-items: center;\n  background: var(--white-background);\n  height: 35px;\n  width: 100%;\n  min-height: 35px;\n  border: 1px solid var(--d9d9e3-border);\n  border-radius: 8px;\n  padding: 0px 14px;\n}\n\n.searchIconsWrappers {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 22px;\n  height: 22px;\n  background: var(--ececf1-background);\n  cursor: pointer;\n  user-select: none;\n  border-radius: 3px;\n}\n\n.searchIcon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 24px;\n  height: 24px;\n  color: var(--_6-color);\n}\n\n.searchInput {\n  flex: 1;\n  padding: 8px;\n  border: none;\n  background: transparent;\n  outline: none;\n}\n\n.searchInput::placeholder {\n  color: var(--_6-color);\n}\n\n\n.contentContainerScroll {\n  overflow: hidden;\n  overflow-y: auto;\n}\n.contentContainer {\n  /* border: 2px dashed var(--ececf1-background); */\n  border-radius: 8px;\n  /* max-height: 60vh; */\n  overflow: scroll;\n}\n\n.contentContainer::-webkit-scrollbar {\n  width: 8px;\n  height: 8px;\n}\n\n.contentContainer::-webkit-scrollbar-thumb {\n  background-color: var(--e2-background);\n  border-radius: 12px;\n}\n\n.contentContainer::-webkit-scrollbar-track {\n  background: var(--white-background);\n}\n\n.noAutomations {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  flex-direction: column;\n  padding: 20px;\n  background-color: var(--white-background);\n}\n\n\n.paginationTableContainer{\n  display: flex;\n  justify-content: end;\n  width: 100%;\n}\n.automationIconContainer{\n  background-color: var(--white-background);\n  transition: background-color 0.3s ease;\n  border-radius: 5px;\n  cursor: pointer;\n  stroke: rgb(119, 119, 119) !important;\n  svg{\n    &:hover {\n      stroke: #8f8f8f !important;\n    }\n  }\n}\n\n.noAutomationsTextWrapper{\n      display: flex;\n    flex-direction: column;\n    align-items: center;\n    margin-bottom: 1%;\n}\n\n.scaleUp {\n  transform: scale(0.08); \n  opacity: 0;\n  transition: transform 0.3s ease, opacity 0.3s ease;\n}\n\n\n.typeContact {\n  display: flex;\n  background-color: var(--white-background);\n  border-radius: 6px;\n  -webkit-border-radius: 6px;\n  -moz-border-radius: 6px;\n  -ms-border-radius: 6px;\n  -o-border-radius: 6px;\n  padding: 12px 20px;\n  gap: 20px;\n  width: 100%;\n  height: fit-content;\n  box-sizing: border-box;\n  /* overflow-x: auto; */\n\n\n  button {\n    background-color: transparent;\n    cursor: pointer;\n    color: var(--_6-color);\n    font-family: Inter;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: 24px;\n    border-radius: 8px;\n    -webkit-border-radius: 8px;\n    -moz-border-radius: 8px;\n    -ms-border-radius: 8px;\n    -o-border-radius: 8px;\n    /* border: 1px solid transparent !important; */\n    border: none !important;\n    /* flex: 1; */\n    background-color: transparent;\n    max-height: 40px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 8px;\n    outline: none;\n    gap: 10px;\n\n    span{\n      background-color: var(--white-background);\n      color: #181818;\n                  height: 16px;\n            width: 16px;\n            display: flex\n;\n            padding: 2px;\n            border-radius: 4px;\n            justify-content: center;\n            align-items: center;\n    }\n}\n\n .selected {\n    background-color: var(--ececf1-background);\n    /* color: var(--_0d-color); */\n    border-radius: 8px;\n    border:none !important;\n    box-shadow:\n      0px 0px 2px 0px var(--_00000008-shadow),\n      0px 0px 0px 0px var(--_00000000-shadow),\n      0px 0px 0px 0px var(--_00000000-shadow);\n  }\n}\n.buttonsContainer{\n  display: flex;\n  justify-content: space-between;\n  width: 100%;\n  background-color: var(--white-background);\n  border-radius: 6px;\n  -webkit-border-radius: 6px;\n  -moz-border-radius: 6px;\n  -ms-border-radius: 6px;\n  -o-border-radius: 6px;\n  padding: 12px 20px;\n\n  .rightButtonsContainer{\n    display: flex;\n    align-items: center;\n    gap: 10px;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `container_Ue4DS`,
	"content": `content_HMBmc`,
	"scaleInitial": `scaleInitial_yEJ3B`,
	"scaleIn": `scaleIn_CVfdz`,
	"scaleOut": `scaleOut_KgRhs`,
	"expand": `expand_HJLTy`,
	"iniAutomateContainer": `iniAutomateContainer_pGa3X`,
	"automateContainer": `automateContainer_P1C8L`,
	"iniContainer": `iniContainer_Ua5qE`,
	"automate_content": `automate_content_CvCNX`,
	"footer": `footer_jhial`,
	"scaleDown": `scaleDown_sX_EE`,
	"fadeOut": `fadeOut_djDEH`,
	"headerLeft": `headerLeft_svBVT`,
	"closeIcon": `closeIcon_meqNN`,
	"backButton": `backButton_Er5FW`,
	"searchContainer": `searchContainer_qIz4a`,
	"searchInputWrapper": `searchInputWrapper_PD_wa`,
	"searchIconsWrappers": `searchIconsWrappers_fQreT`,
	"searchIcon": `searchIcon_rMW2B`,
	"searchInput": `searchInput_hkuu4`,
	"contentContainerScroll": `contentContainerScroll_lc0N_`,
	"contentContainer": `contentContainer_su_0f`,
	"noAutomations": `noAutomations_pSoZ3`,
	"paginationTableContainer": `paginationTableContainer_ljneZ`,
	"automationIconContainer": `automationIconContainer_pbIS4`,
	"noAutomationsTextWrapper": `noAutomationsTextWrapper_R8SWL`,
	"scaleUp": `scaleUp_O5oc8`,
	"typeContact": `typeContact_U59k7`,
	"selected": `selected_Ps0lE`,
	"buttonsContainer": `buttonsContainer_xJ_pF`,
	"rightButtonsContainer": `rightButtonsContainer_Sgl63`
};
export default ___CSS_LOADER_EXPORT___;
